module.exports = __webpack_public_path__ + "media/src/public/images/mail/pretty/stopwatch-35d779e23e14dc291b523b736cec8e36.png";